import { PAGE_TYPES } from '@wix/wix-data-client-common'
import { buildPageName } from '../utils/buildPageName'

import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { PresetDefinition } from '../../presets/types'

export const addPage = async ({
  editorSdkProxy,
  preset,
  newCollectionName,
}: {
  editorSdkProxy: EditorSDK
  preset: PresetDefinition
  newCollectionName: string
}) => {
  const pageTitle = buildPageName({
    collectionName: newCollectionName,
    pageType: PAGE_TYPES.ITEM,
  })

  const pageDefinition = preset.pages.find(page => page.type === 'itemPage')

  const pageRef = await editorSdkProxy.document.pages.add({
    title: pageTitle,
    definition: pageDefinition!.definition,
    shouldAddMenuItem: true,
    shouldNavigateToPage: false,
  })

  return { pageRef }
}
